export default {
  leastDrawn: 'সর্বনিম্ন ড্র হয়েছে',
  mostDrawn: 'সর্বাধিক ড্র হয়েছে',
  leastPlayed: 'সর্বনিম্ন খেলা হয়েছে',
  mostPlayed: 'সর্বাধিক খেলা হয়েছে',
  drawFrom: 'থেকে ড্র',
  h: 'ঘ', // ঘণ্টার সংক্ষিপ্ত রূপ
  startingIn: 'শুরু হবে',
  waitingForDrawnFrom: 'ড্র উৎসের জন্য অপেক্ষা করা হচ্ছে',
  displayingDrawFrom: 'ড্র উৎস দেখানো হচ্ছে',
  lotteryDraw: 'লটারি ড্র',
  eventId: 'ইভেন্ট আইডি',
  bettingShortcuts: 'বেটিং শর্টকাট',
  draw: 'ড্র',
  next5Events: 'পরবর্তী {value}টি প্রদর্শিত হচ্ছে',
  events: 'ইভেন্টগুলি',
  schedule: 'সময়সূচি',
  next: 'পরবর্তী',
  event: 'ইভেন্ট',
  later: 'পরে',
  statistics: 'পরিসংখ্যান',
  lastnRounds: 'শেষ {value} রাউন্ড',
  bettingOffer: 'বেটিং অফার',
  notDisplayed: 'প্রদর্শিত নয়',
  latestResults: 'সর্বশেষ ফলাফল',
  drawnAt: '{value} সময় ড্র হয়েছে',
  additionalBetting: 'অতিরিক্ত বেটিং',
  drawSumEvenOdd: 'ড্র মোট সংখ্যা জোড় না বিজোড়',
  drawSumTotal: 'ড্র মোট সংখ্যা',
  drawSumRange: 'ড্র মোট পরিসর',
  waitingForDrawNo: 'ড্র নম্বর {value}-এর জন্য অপেক্ষা',
  nextDraw: 'পরবর্তী ড্র',
  waitingForDraw: 'ড্র-এর জন্য অপেক্ষা করা হচ্ছে',
  drawCompleted: 'ড্র সম্পন্ন হয়েছে',
  drawDisplayTemporarilyNotAvailable: 'ড্র প্রদর্শন সাময়িকভাবে অনুপলব্ধ',
  connectionError: 'সংযোগ ত্রুটি!',
  reconnecting: 'পুনরায় সংযুক্ত করা হচ্ছে...',
  number: 'সংখ্যা',
  headerNumberDescriptionUp: 'ইভেন্ট',
  headerNumberDescriptionDown: 'সংখ্যা',
};
